module.exports = __webpack_public_path__ + "img/p2_sp@2x.ed163002.png";